import axios from 'axios'
import { getApiUrl } from '@/utils/appConfig'

export default () => {
  const config = {
    baseURL: getApiUrl()
  }

  return {
    baseURL: config.baseURL,
    api: axios.create(config)
  }
}
